<div class="info-page">
  <header class="info-hero">
    <p class="info-kicker">Quick answers</p>
    <h1 class="info-heading">FAQ</h1>
    <p class="info-sub">Tap a question to see how LootLucky works.</p>
  </header>

  <div class="info-panel faq-wrap">
    <mat-accordion class="faq-accordion" multi>
      <mat-expansion-panel hideToggle *ngFor="let faq of faqs; let i = index" class="faq-panel">
        <mat-expansion-panel-header class="faq-header">
          <span class="faq-index">{{ i + 1 }}</span>
          <div class="faq-header-content">
            {{ faq.question }}
          </div>
          <mat-icon class="faq-icon">expand_more</mat-icon>
        </mat-expansion-panel-header>
        <div [innerHTML]="faq.answer" class="faq-answer"></div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
